import { Box, useTheme } from "@mui/material"
import Grid from "@mui/material/Grid"
import { forwardRef, memo } from "react"
import { TIMELINE_ROW } from "../../../../style/sizing"
import TimeStampWrapper from "./TimeStampWrapper"
import TimelinePlayhead from "./TimelinePlayhead"

interface Props {
    width: number
    thumbHeight: number | undefined
    visibility: "visible" | "hidden"
    timeStepsDensity: number
    duration: number
    effectiveDuration: number
    handleChange: (val: number) => void
    handleClickTimeStamp: (time: number) => void
}

const TimeStamps = memo(
    forwardRef<HTMLDivElement, Props>(
        (
            {
                width,
                thumbHeight,
                visibility,
                timeStepsDensity,
                duration,
                effectiveDuration,
                handleChange,
                handleClickTimeStamp,
            },
            ref
        ) => {
            const theme = useTheme()

            const arrayOfFrames: number[] = [...Array(timeStepsDensity)]
            const tweenWidth: number = duration > 0 ? width / duration : width // width per sec

            return (
                <>
                    <Box
                        sx={{
                            zIndex: 60,
                            position: "absolute",
                            width: TIMELINE_ROW.headingWidth + "px",
                            height: TIMELINE_ROW.height + "px",
                            background: theme.palette.grey[800],
                            visibility,
                            textAlign: "center",
                        }}
                    ></Box>

                    <Grid
                        ref={ref}
                        className="custom-timeStamps-wrapper"
                        container
                        direction="row"
                        justifyContent="space-between"
                        sx={{
                            top: "0px",
                            position: "sticky",
                            zIndex: 50,
                            flexBasis: 20,
                            paddingLeft: TIMELINE_ROW.headingWidth + "px",
                            visibility,
                            height: TIMELINE_ROW.height + "px",
                        }}
                    >
                        <TimelinePlayhead
                            thumbHeight={thumbHeight}
                            width={effectiveDuration * tweenWidth}
                            visibility={visibility}
                            handleChange={handleChange}
                        />
                        <Grid
                            container
                            direction="row"
                            sx={{
                                position: "absolute",
                                width: width + "px",
                                height: TIMELINE_ROW.height + "px",
                                overflow: "visible",
                                background: theme.palette.grey[800],
                                paddingBottom: 3,
                            }}
                        >
                            {arrayOfFrames.map((_, index) => (
                                <TimeStampWrapper
                                    key={index}
                                    index={index}
                                    width={width}
                                    handleClickTimeStamp={handleClickTimeStamp}
                                />
                            ))}
                        </Grid>
                    </Grid>
                </>
            )
        }
    )
)

export default TimeStamps
